import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "service-detail"
}
const _hoisted_2 = { class: "detail-wrap" }
const _hoisted_3 = { class: "detail-actions" }
const _hoisted_4 = { class: "detail-content" }
const _hoisted_5 = { class: "detail-wrap detail-grid" }
const _hoisted_6 = { class: "benefit-list" }
const _hoisted_7 = { class: "quality-card" }
const _hoisted_8 = { class: "process-section" }
const _hoisted_9 = { class: "detail-wrap" }
const _hoisted_10 = { class: "process-grid" }
const _hoisted_11 = {
  key: 1,
  class: "not-found"
}

import { ArrowLeft, ArrowRight, Check, ClipboardCheck, Phone, ShieldCheck } from "lucide-vue-next";
import { computed, watchEffect } from "vue";
import { useRoute } from "vue-router";
import { getService } from "@/data/services";
import "@/assets/styles/service-detail.css";


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceDetailView',
  setup(__props) {

const route = useRoute();
const service = computed(() => getService(String(route.params.slug)));
watchEffect(() => { if (service.value) document.title = `${service.value.title} | Dachdecker Beispiel`; });

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (service.value)
    ? (_openBlock(), _createElementBlock("main", _hoisted_1, [
        _createElementVNode("section", {
          class: "detail-hero",
          style: _normalizeStyle({ '--service-image': `url(/images/services/${service.value.slug}.png)` })
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_RouterLink, {
              to: "/leistungen",
              class: "back-link"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ArrowLeft)),
                _cache[0] || (_cache[0] = _createTextVNode(" Alle Leistungen", -1))
              ]),
              _: 1
            }),
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "section-badge" }, "Leistung im Detail", -1)),
            _createElementVNode("h1", null, _toDisplayString(service.value.title), 1),
            _createElementVNode("p", null, _toDisplayString(service.value.intro), 1),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_RouterLink, {
                to: "/kontakt",
                class: "detail-btn primary"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Phone)),
                  _cache[1] || (_cache[1] = _createTextVNode(" Projekt anfragen", -1))
                ]),
                _: 1
              }),
              _cache[2] || (_cache[2] = _createElementVNode("a", {
                href: "tel:+49123456789",
                class: "detail-btn secondary"
              }, "Direkt anrufen", -1))
            ])
          ])
        ], 4),
        _createElementVNode("section", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "section-badge" }, "Leistungsumfang", -1)),
              _cache[5] || (_cache[5] = _createElementVNode("h2", null, "Darauf können Sie sich verlassen", -1)),
              _createElementVNode("ul", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(service.value.benefits, (item) => {
                  return (_openBlock(), _createElementBlock("li", { key: item }, [
                    _createVNode(_unref(Check)),
                    _createTextVNode(_toDisplayString(item), 1)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("aside", _hoisted_7, [
              _createVNode(_unref(ShieldCheck)),
              _cache[6] || (_cache[6] = _createElementVNode("span", null, "Meisterqualität", -1)),
              _cache[7] || (_cache[7] = _createElementVNode("h3", null, "Sauber geplant. Fachgerecht ausgeführt.", -1)),
              _cache[8] || (_cache[8] = _createElementVNode("p", null, "Sie erhalten eine verständliche Empfehlung, transparente Schritte und eine sorgfältige Übergabe.", -1))
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "process-heading" }, [
              _createElementVNode("span", { class: "section-badge" }, "Unser Ablauf"),
              _createElementVNode("h2", null, "In vier klaren Schritten")
            ], -1)),
            _createElementVNode("ol", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(service.value.steps, (step, index) => {
                return (_openBlock(), _createElementBlock("li", { key: step }, [
                  _createElementVNode("span", null, "0" + _toDisplayString(index + 1), 1),
                  _createVNode(_unref(ClipboardCheck)),
                  _createElementVNode("strong", null, _toDisplayString(step), 1)
                ]))
              }), 128))
            ]),
            _createVNode(_component_RouterLink, {
              to: "/kontakt",
              class: "detail-cta"
            }, {
              default: _withCtx(() => [
                _cache[9] || (_cache[9] = _createTextVNode("Unverbindlich beraten lassen ", -1)),
                _createVNode(_unref(ArrowRight))
              ]),
              _: 1
            })
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("main", _hoisted_11, [
        _cache[12] || (_cache[12] = _createElementVNode("h1", null, "Leistung nicht gefunden", -1)),
        _createVNode(_component_RouterLink, { to: "/leistungen" }, {
          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
            _createTextVNode("Zurück zu allen Leistungen", -1)
          ]))]),
          _: 1
        })
      ]))
}
}

})